import Link from "../Link";
import { useThemeDefaults } from "../utils";
var HeadingLink = useThemeDefaults(function () {
  return {
    hoverColor: "ctrl",
    color: "title",
    hoverTextDecoration: "none"
  };
}, Link);
export default HeadingLink;